import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { TitleBlockInfo } from '../../object3D/TitleBlock/TitleBlockInfo';
import { TitleBlockInfoComponent } from '../title-block-info/title-block-info.component';
import { environment } from '../../../../../environments/environment';
import { EstimatorsService } from '../../estimators.service';


@Component({
    selector: 'app-title-block',
    templateUrl: 'title-block.component.html',
    styleUrls: ['./title-block.component.scss']
})


export class TitleBlockComponent {

    @ViewChild('editorElement') editorElement: ElementRef;
    @ViewChild('sizeCalculationDiv') sizeCalculationDiv: ElementRef;
    date: Date;
    info: TitleBlockInfo;
    estimators: any = [];
    needDetails: boolean = false;
    private URL: string = environment.apiUrl;
    contractors: any;

    constructor(
        private estimatorsService: EstimatorsService,
        private dialogRef: MatDialogRef<TitleBlockComponent>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: TitleBlockInfo | null
    ) {
        this.date = new Date();
        this.info = new TitleBlockInfo(this.date);
        this.estimatorsService.getEstimators()
        .subscribe(contractors => {
            this.contractors = contractors;
            this.contractors.forEach(e => {
                this.estimators.push(e.firstName + " " + e.lastName);
            });
        });
    }

    includeDetails() {
        if (!this.needDetails) {

            const dialogRef = this.dialog.open(TitleBlockInfoComponent, {
                width: '315px',
                data: this.info,
                position: {
                    left: '0'
                },
                hasBackdrop: false
            });
            
            dialogRef.afterClosed().subscribe((result: TitleBlockInfo | undefined) => {
                if (result) {
                    this.info = result;
                }
            });
        }
    }


    async apply() {
        this.info.Note = this.editorElement.nativeElement.innerText;
        this.dialogRef.close(this.info);

    }

    async close() {

    }

}


// WEBPACK FOOTER //
// ./src/app/services/proTools/ng-components/title-block/title-block.component.ts